import buttonService from './button';
import utils from './utils';
import hproLog from './log';
import notificationAPI from './notification';
import webPushConfiguration from './webpush-configuration';
import webPushRegistration from './registration';
import subscriptionService from './subscription';

export default function webPushClient() {
    if (!(this instanceof webPushClient)) {
        return new webPushClient();
    }

    if (!notificationAPI.isSupported()) {
        // hproLog('WebPush API or Notification API not supported');
        return null;
    }
    
    var self = this;

    var webPushSubscription = null;
    var webPushButton = null;
    var webPushConfig = new webPushConfiguration({});

    var serviceWorkerController = null;
    var serviceWorkerRegistration = null;

    var onRegister = null;

    function sendCommand(command, data) {
        return new Promise(function (resolve, reject) {
            if (!serviceWorkerRegistration) {
                reject();
            }

            // Create a Message Channel
            var msg_chan = new MessageChannel();

            // Handler for recieving message reply from service worker
            msg_chan.port1.onmessage = function (event) {
                if (event.data.error) {
                    reject(event.data.error);
                } else {
                    resolve(event.data);
                }
            };

            // Send message to service worker along with port for reply
            serviceWorkerController.postMessage({
                command: command,
                data: data,
            }, [msg_chan.port2]);
        });
    };

    self.init = function (initialConfig, cbSuccess, cbError) {
        if(initialConfig.logEnable) {
            hproLog.enable();
        }
        utils.merge(webPushConfig, initialConfig);


        if (initialConfig['identifier']) {
            hproLog('[init][identifier] set');
            localStorage.setItem('hpro2.webpush_identifier', initialConfig['identifier']);
        }

        var s = new Promise(function (resolve, reject) {
            var allwaysResolve = function (someData) {
                resolve();
            }

            hproLog('[init][register] start');
            self.register(function (worker) {
                hproLog('[init][register] success');

                // get local identifier
                var localStorageCdsIdentifier = self.getIdentifier();
                hproLog('[init][identifier]', localStorageCdsIdentifier);

                // get local token
                var localStorageToken = self.getToken();
                hproLog('[init][token]', localStorageToken);

                // Init notifyButton
                if (initialConfig['notifyButton'] && initialConfig['notifyButton']['enable']) {
                    hproLog('[init][register][button]');
                    // Override with initial config for autosubscribe
                    webPushConfig['autoSubscribe'] = initialConfig['autoSubscribe'] == undefined ? true : initialConfig['autoSubscribe'];
                    webPushButton = new buttonService(self, initialConfig['notifyButton']);
                }
                
                hproLog('[init] send command start');
                sendCommand('init', initialConfig).then(function (response) {
                    // var isSubscribing = false;
                    // var subscribeIfGranted = function (action, data) {
                    //     if (isSubscribing) {
                    //         allwaysResolve();
                    //         return;
                    //     }

                    //     isSubscribing = true;

                    //     if (notificationAPI.getPermission() == 'granted'
                    //         && localStorageToken !== 'unsubscribed'
                    //     ) {
                    //         webPushSubscription.create().then(function (response) {
                    //             self.update({
                    //                 identifier: localStorageCdsIdentifier
                    //             }).then(allwaysResolve, allwaysResolve);
                    //         }, allwaysResolve);
                    //         return;
                    //     }
                    //     // if notification granted create new subscription
                    //     resolve();
                    // }

                    hproLog('[init] send command success');
                    webPushSubscription.getToken().then(function (token) {
                        if (localStorageToken === 'unsubscribed') {
                            hproLog('[init] unsubscribed');
                            resolve();
                            return;
                        }

                        if(!webPushConfig.autoSubscribe){
                            hproLog('[init] autoSubscribe false');
                            resolve();
                            return;
                        }

                        // We have a token, this means that a subscription object is present
                        // 1. Can have token and identifier
                        // 2. No identifier is present
                        if (token && localStorageCdsIdentifier && token != localStorageToken) {
                            hproLog('[init] hasToken & hasCdsIdentifier && token != storage[token]', token, localStorageCdsIdentifier, localStorageToken);
                            self.update().then(allwaysResolve, allwaysResolve);
                        }
                        else if (token && !localStorageCdsIdentifier) {
                            hproLog('[init] hasToken & !hasCdsIdentifier', token);
                            var p = self.subscribe({
                                identifier: localStorageCdsIdentifier
                            });
                            p.then(allwaysResolve, allwaysResolve);
                        }
                        else {
                            hproLog('[init] !hasToken & !hasCdsIdentifier');
                            allwaysResolve();
                        }
                    }, function (reason) {
                        hproLog('[init] reasons', reason);

                        var permissionStatus = notificationAPI.getPermission();
                        hproLog('permission status', permissionStatus);
                        if ((permissionStatus === 'default' || permissionStatus === 'denied')
                            && localStorageCdsIdentifier
                            && localStorageToken !== 'unsubscribed'
                        ) {
                            hproLog('WE HAVE IT ALL, now unsubscribe');
                            
                            if (webPushConfig.whenUnsubscribed == 'remove_identity') {
                                hproLog('[init][remove identity]');
                                self.unsubscribe().then(allwaysResolve, allwaysResolve);
                                return;
                            }
                        } else if (notificationAPI.getPermission() == 'granted'
                            && localStorageToken !== 'unsubscribed'
                        ) {
                            switch(reason.reason) {
                            case ('application_server_key_mismatch'):
                                hproLog('[init][application_server_key_mismatch]');
                                self.update().then(allwaysResolve, allwaysResolve);
                                return;
                            case ('no_subscription'):
                                hproLog('[init][no_subscription]');

                                if(webPushConfig.autoSubscribe){
                                    self.subscribe().then(allwaysResolve, allwaysResolve);
                                } else {
                                    allwaysResolve();
                                }
                                // self.subscribe().then(allwaysResolve, allwaysResolve);
                                return;
                            default:
                                break;
                            }
                        }

                        allwaysResolve();
                    });
                }, utils.rejectWithReason(reject, 'init', 'Unable to initialize'));
            }, utils.rejectWithReason(reject, 'register', 'Unable to register'));
        });

        utils.applyPromiseCallbacks(s, cbSuccess, cbError);

        return s;
    };

    /* self.sendCommand = sendCommand; */

    self.onRegister = onRegister;

    self.register = function (cbSuccess, cbError) {
        var p = new Promise(function (resolve, reject) {
            webPushRegistration(webPushConfig.workerFile, function (reg) {
                serviceWorkerController = reg.controller;
                serviceWorkerRegistration = reg.registration;
                webPushSubscription = new subscriptionService(reg.pushManager, webPushConfig);
                resolve();
            }, reject);
        });

        utils.applyPromiseCallbacks(p, cbSuccess, cbError);

        return p;
    };

    self.isSubscribed = function (cbSuccess, cbError) {
        var p = new Promise(function (resolve, reject) {
            if (!serviceWorkerRegistration) {
                utils.rejectWithReason(reject, 'no_service_worker', 'Service worker not registered')(notificationAPI.getPermission());
                return;
            }

            function resolveWithPermission() {
                resolve(notificationAPI.getPermission());
            }

            function rejectWithPermission() {
                utils.rejectWithReason(reject, 'not_subscribed', 'No subscription is made')(notificationAPI.getPermission());
            }

            /* self.sendCommand('getStatus', null).then(function (e) { */
            /* self.sendCommand('isSubscribed', null) */
            webPushSubscription
                .isSubscribed()
                .then(function (response) {
                    var cdsIdentifier = self.getIdentifier();

                    if (!cdsIdentifier) {
                        utils.rejectWithReason(reject, 'subscription_identifier_missing', 'Subscription CDS Identifier is missing')(notificationAPI.getPermission());
                        return;
                    }

                    resolveWithPermission(response);
                }, reject)
                ;
            /* }, rejectWithPermission); */
        });

        utils.applyPromiseCallbacks(p, cbSuccess, cbError);

        return p;
    };

    self.subscribe = function (customData, customHeaders, cbSuccess, cbError) {
        hproLog('[subscribe] start');
        var data = utils.merge({}, customData || {});
            data['identifier'] = data['identifier']
                || webPushConfig['identifier']
                || self.getIdentifier()
                ;
        if (data['identifier'] == 'invalid' || !data['identifier']) {
        // if (data['identifier'] == 'invalid') {
            delete(data['identifier']);
        }
        var s = new Promise(function (resolve, reject) {
            function __subscribe() {
                hproLog('[subscribe][subscription] create');
                webPushSubscription.create(data, customHeaders || {}).then(function (cdsUserData) {
                    hproLog('[subscribe][subscription] create success');
                    if (cdsUserData.cds_contact_id) {
                        localStorage.setItem('hpro2.webpush_identifier', cdsUserData.cds_contact_id);
                        localStorage.setItem('hpro2.webpush_token', cdsUserData.subscription.token);
                        sendCommand('setUserData', cdsUserData);
                        resolve(cdsUserData);
                    }
                    else {
                        utils.rejectWithReason(reject, 'subscribe_failed', 'Unable to get subscription')(cdsUserData);
                    }
                }, function (reason) {
                    hproLog('[subscribe][subscription] create error', reason);
                    if (reason.error && reason.error.code == 'invalid_identifier') {
                        hproLog('[subscribe][subscription] create error invalid_identifier');
                        localStorage.removeItem('hpro2.webpush_identifier', null);
                    // try to create a new subscription
                        data['identifier'] = 'invalid';
                        self.subscribe(data, customHeaders, resolve, reject);
                    }
                    else {
                        hproLog('[subscribe][subscription] create error items', reason);
                        utils.rejectWithReason(reject, 'subscribe_failed', 'Unable to send subscription')(reason);
                    }
                // }, utils.rejectWithReason(reject, 'subscribe_failed', 'Unable to send subscription'));
                }, function(err){
                    hproLog('[subscribe][subscription] CreateError', err);
                });
            }

            hproLog('[subscribe] isSubscribed');
            self.isSubscribed(__subscribe, function (reason) {
                hproLog('[subscribe] isSubscribed no', reason);
                var state = notificationAPI.getPermission();

                if (state === 'default') {
                    hproLog('[subscribe][permit]', state);
                    self.permit(__subscribe, reject);
                }
                else if (state === 'granted') {
                    __subscribe();
                }
                else {
                    utils.rejectWithReason(reject, 'permission', 'There are no permissions')(reason);
                }
            }, reject);
        });

        return utils.applyPromiseCallbacks(s, cbSuccess, cbError);
    };

    self.update = function (customData, customHeaders, cbSuccess, cbError) {
        var data = utils.merge({}, customData || {});
            data['identifier'] = data['identifier']
                || webPushConfig['identifier']
                || self.getIdentifier()
                ;

        if (data['identifier'] == 'invalid') {
            delete(data['identifier']);
        }

        var p = new Promise(function (resolve, reject) {
            var cdsIdentifier = self.getIdentifier();

            if (!cdsIdentifier) {
                utils.rejectWithReason(reject, 'subscription_missing', 'Subscription is missing')();
                return;
            }

            var setUserData = function (cdsUserData) {
                localStorage.setItem('hpro2.webpush_identifier', cdsUserData.cds_contact_id);
                localStorage.setItem('hpro2.webpush_token', cdsUserData.subscription.token);
                sendCommand('setUserData', cdsUserData);
                resolve(cdsUserData);
            }

            var subscriptionUpdateAction = function (response) {
                var p = webPushSubscription.update(
                    data,
                    customHeaders || {},
                    false
                );

                p.then(setUserData, parseErrors);

                return p;
            }

            var parseErrors = function (reason) {
                if (reason.reason == 'application_server_key_mismatch') {
                    self.unsubscribe(customData, customHeaders).then(function (response) {
                        self.subscribe(customData, customHeaders, resolve, reject);
                    }, reject);
                }
                else if (reason.error && reason.error.code == 'invalid_identifier') {
                    localStorage.removeItem('hpro2.webpush_identifier', null);
                // try to create a new subscription
                    data['identifier'] = 'invalid';
                    self.subscribe(data, customHeaders, resolve, reject);
                }
                else {
                    utils.rejectWithReason(reject, 'subscribe_update_failed', 'Unable to send update subscription')(reason);
                }
            }

            webPushSubscription.isSubscribed().then(subscriptionUpdateAction, parseErrors);
            
        });

        utils.applyPromiseCallbacks(p, cbSuccess, cbError);

        return p;
    };

    self.unsubscribe = function (customData, customHeaders, cbSuccess, cbError) {
        var data = utils.merge({}, customData || {});
            data['identifier'] = data['identifier']
                || webPushConfig['identifier']
                || self.getIdentifier()
                ;

        data['activity_name'] = "unsubscribed";

        var p = new Promise(function (resolve, reject) {
            var cdsIdentifier = self.getIdentifier();

            if (!cdsIdentifier) {
                utils.rejectWithReason(reject, 'subscription_missing', 'Subscription is missing')();
                return;
            }

            webPushSubscription.remove(
                data || {},
                customHeaders || {},
                true
            ).then(function (response) {
                // response.json().then(function (cdsUserData) {
                localStorage.setItem('hpro2.webpush_token', 'unsubscribed');
                if (webPushConfig.whenUnsubscribed === 'remove_identity') {
                    localStorage.removeItem('hpro2.webpush_identifier', null);
                }
                // sendCommand('setUserData', cdsUserData);
                resolve('unsubscribed');
                // }, rejectWithReason(reject, 'unsubscribe_invalid_data', 'Unsubscribe has invalid data'));
            }, function (reason) {
                if (webPushConfig.whenUnsubscribed === 'remove_identity') {
                    localStorage.removeItem('hpro2.webpush_identifier', null);
                }

                if (reason.data && reason.data.error && reason.data.error.code == 'invalid_identifier') {
                    localStorage.removeItem('hpro2.webpush_identifier', null);
                    resolve('unsubscribed');
                }
                else {
                    utils.rejectWithReason(reject, 'unsubscribe_failed', 'Unable to unsubscribe')(reason);
                }
            });
        });

        utils.applyPromiseCallbacks(p, cbSuccess, cbError);

        return p;
    };

    /* self.test = function (customData, customHeaders, cbSuccess, cbError) {
        var p = webPushSubscription.test(
            customData || {},
            customHeaders || {}
        );

        utils.applyPromiseCallbacks(p, cbSuccess, cbError);

        return p;
    }; */

    self.permit = function (cbSuccess, cbError) {
        var p = notificationAPI.permit();

        utils.applyPromiseCallbacks(p, cbSuccess, cbError);

        return p;
    };

    self.getIdentifier = function () {
        return localStorage.getItem('hpro2.webpush_identifier');
    };

    self.getToken = function () {
        return localStorage.getItem('hpro2.webpush_token');
    };

}


//////////////////
// WEBPACK FOOTER
// ./src/services/webpush-client.js
// module id = 13
// module chunks = 0